import {globalUser} from "./globals.js";
import {
    getUniqueChampionships,
    compareChampionships,
    checkAreChampionshipsEqual,
    getChampionshipMatchData
} from "./championships.js";
import {getTagTeamSuperstars} from "../models/tagTeam.js";
import {
    addSuperstarRelationships,
    getSuperstarChampionships, getSuperstarCurrentGimmick,
    getSuperstarFactions, getSuperstarFeuds, getSuperstarGimmicks,
    getSuperstarManagedSuperstars,
    getSuperstarManager, getSuperstarNegotiations,
    getSuperstarRelationships, getSuperstarRoster,
    getSuperstarTagTeams, getSuperstarTalentRequests, getSuperstarWonTournaments, removeSuperstarChampionships,
    removeSuperstarManager,
    setSuperstarManager
} from "../models/superstar.js";
import {
    getFactionSuperstars
} from "../models/faction.js";
import {graphicsData} from "../data/graphics.js"
import {Superstars, db, Relationships, TalentRequests, Negotiations, CompanyLogs} from "../models/models.js";
import {
    addCompanyCompanyAlerts,
    addCompanyCompanyLogs,
    addCompanyMessages, addCompanyNewsItems, addCompanyRelationships, getCompanyChampionships,
    getCompanyCompanyLogs,
    getCompanyGame, getCompanyStaff
} from "../models/company.js";
import {
    captureError,
    getArrayMaxByProperty, getCurrentGame, getHairColor, getMonthsDifference,
    getRandomChoice,
    getRandomInt, getRandomUniform, getRosterMemberPopularity,
    getTalentCompany, limitValueBetweenRange,
    objectInArray, shuffle, weightedChoice
} from "./helpers.js";
import {disbandFaction, processFactionXpChangeForFaction, removeSuperstarsFromFaction} from "./factions.js";
import {
    getChampionshipCurrentReign,
    getChampionshipMatchContract,
    getChampionshipSuperstar
} from "../models/championship.js";
import {getMatchContractEvent} from "../models/matchContract.js";
import {getManagerManagedTalent} from "./managers.js";
import {removeTagTeam} from "./tagTeams.js";
import {traitsData} from "../data/traits.js";
import {transferTalentToRoster} from "./rosters.js";
import {
    addFormerCompanyRelationship,
    createCompanyAlert, getChampionshipPopularityDecrease,
    getChampionshipReignLength, getCompanyRosterByType, getHighestLevelStaffMemberByRole,
    getMatchGimmickFatigueIncrease, getRandomStaffMemberByRole, getStaffAgeMultiplier,
    getTutorialStateName, updateStaffMemberXp
} from "./companies.js";
import {injuriesData} from "../data/injuries.js";
import {checkTalentRequestAction} from "./talentRequests.js";
import {
    createCompetitorSuperstarLeavingMessage,
    createCompetitorSuperstarLeftMessage, createLeavingMessage,
    createLeftCompanyMessage,
    createLeftCompanySuperstarMessage, createNoLongerUnhappyMessage, createNotLeavingMessage,
    createTraitAcquiredMessage, createUnhappyMessage
} from "./messages.js";
import {charactersData} from "../data/characters.js";
import {addRosterSuperstars, getRosterCompany, getRosterSuperstars} from "../models/roster.js";
import {CompanyLog} from "../models/companyLog.js";
import {getGameMainUserCompany} from "./games.js";
import {getFeudRating} from "./feuds.js";
import {generateNewsItem} from "./news.js";
import {Relationship} from "../models/relationship.js";
import {getTournamentEvent} from "../models/tournament.js";
import {processPowSuperstarLeavesCompany} from "./passionOfWrestling.js";

function getRankFromPopularity(popularity) {
    if (popularity >= 800) {
        return 'Main Eventer'
    } else if (popularity >= 600) {
        return 'Upper Midcarder'
    } else if (popularity >= 400) {
        return 'Lower Midcarder'
    } else {
        return 'Jabroni'
    }
}

async function getNextRank(talent) {  // get_next_rank
    let popularity = await getRosterMemberPopularity(talent);
    if (popularity >= 800) {
        return null
    }
    else if (popularity >= 600) {
        return 'Main Eventer'
    }
    else if (popularity >= 400) {
        return 'Upper Midcarder'
    }
    else {
        return 'Lower Midcarder'
    }
}

function getInjuryReturnTime(superstar, doctor = null) {  // Previously get_injury_return_time
    let length = superstar.injured;

    // Get doctor level
    let level = doctor ? doctor.level : 1;

    if (level >= 3 || superstar.workableInjury) {
        return length.toString();
    }
    else {
        if (!superstar.injuryReturnMin || !superstar.injuryReturnMax) {
            evaluateInjury(superstar, doctor);
        }
        return `${superstar.injuryReturnMin} to ${superstar.injuryReturnMax}`;
    }
}

function evaluateInjury(superstar, doctor = null) {
    let length = superstar.injured;

    // Get doctor level
    let level = doctor ? doctor.level : 1;

    if (level >= 3 || superstar.workableInjury) {
        superstar.injuryReturnMin = length;
        superstar.injuryReturnMax = length + 1;
        return `${length}`;
    } else {
        let rangeLength;
        if (length < 6) {
            rangeLength = 2;
        } else if (length < 10) {
            rangeLength = 4;
        } else {
            rangeLength = 6;
        }
        if (level === 2) {
            rangeLength /= 2;  // Lower range for level 2 doctor
        }

        // Get random starting point, add range
        let lowerValue = length + getRandomInt(-rangeLength, 0);
        if (lowerValue <= 0) {
            lowerValue = 1;
        }
        let upperValue = lowerValue + rangeLength;

        superstar.injuryReturnMin = lowerValue;
        superstar.injuryReturnMax = upperValue;

        return `${lowerValue} to ${upperValue}`;
    }
}


function getSuperstarChampionshipsAll(superstar, championships) {  // get_superstar_championships_all
    let superstarChampionships = championships.filter(x => x.superstarId === superstar.$loki);
    let uniqueChampionships = getUniqueChampionships(superstarChampionships);
    return uniqueChampionships.map(x => x.name);
}

function checkAvailability(superstar, allowManagers = true, factionSegment = false,
                           allowWorkableInjury = true) {  // check_availability
    if (allowManagers === false && (superstar.fullTimeManager && superstar.activeEffect !== 'one_match_appearance')) {
        return false;
    }

    // Check injury
    let injuredCheck;
    if (allowWorkableInjury) {
        injuredCheck = superstar.injured > 0 && !superstar.workableInjury
    }
    else {
        injuredCheck = superstar.injured
    }

    // For faction segments, don't check retired, no appearances or injured
    let appearancesCheck = superstar.partTimer && superstar.appearances <= 0;
    let retiredCheck = superstar.retired;
    if (factionSegment) {
        retiredCheck = false;
        appearancesCheck = false;
        injuredCheck = false;
    }

    // Skip injured, part timer with no appearances and retired
    if (injuredCheck || appearancesCheck || retiredCheck || superstar.unavailable || superstar.suspensionMonths > 0 ||
        superstar.dead) {
        return false;
    }

    return true;
}

function checkSuperstarBrandAvailability(event, superstar, superstarChampionships = null) {  // check_superstar_brand_availability
    // Check if any superstar championships are non exclusive or exclusive to this brand

    let allowChampion = false;
    if (superstarChampionships) {
        allowChampion = superstarChampionships.some(x => !x.brandName || x.brandName === event.brandName);
    }

    // Return true if superstar passes brand availability check
    let eventBrandName = event ? event.brandName : null;
    let eventActiveEffect = event ? event.activeEffect : null;
    return checkObjectBrandAvailability(superstar, eventBrandName, allowChampion, eventActiveEffect);
}

function checkObjectBrandAvailability(object, eventBrandName, allowChampion = false, eventActiveEffect = null) {  // check_object_brand_availability
    // Return true if no event brand name present or object / its championship is not exclusive to a brand or belongs
    // to this brand or event has allow_other_brands active effect
    if (eventBrandName && object.brandName && !allowChampion &&
        !['allow_other_brands', 'allow_other_brands_extended'].includes(eventActiveEffect)) {
        return object.brandName === eventBrandName;
    }
    return true;
}

function checkSuperstarSegmentAvailability(s, checkInjured = true) {
    // Skip injured (except workable injury), suspended, unavailable and dead
    if ((checkInjured && s.injured > 0 && !s.workableInjury) || s.suspensionMonths > 0 || s.unavailable || s.dead) {
        return false;
    }
    return true;
}

async function getSuperstarDisplayData({superstar, scenarioInformation = false, doctor = null,
                                        includeChampionships = true, getTeamsAndFactions = false,
                                        rosterSuperstars = null, managedSuperstars = null,
                                        manager = null, managersUsed = null, getCurrentAttire = false,
                                        getGimmick = true, superstarChampionships = null,
                                        superstarTagTeamsAndFactions = null, getTagTeamPartners = false,
                                        getTournamentsWon = false,
                                        game = null} = {}) {  // Previously get_superstar

    // Copy data
    let superstarData = JSON.parse(JSON.stringify(superstar));

    // Get rank
    superstarData["rank"] = getRankFromPopularity(superstar.popularity);

    // Check if hot, increase workrate/charisma
    if (superstar.hot && !scenarioInformation) {
        superstarData["charisma"] += 1;
        superstarData["workrate"] += 1;
    }

    // Get injury return time
    if (superstar.injured) {
        superstarData["injuryTime"] = getInjuryReturnTime(superstar, doctor)
    }

    // Get can unlearn traits
    superstarData['canUnlearnTraits'] = getCanUnlearnTraitsForSuperstar(superstar);

    // Get graphic
    superstarData["graphic"] = getGraphicForSuperstar(superstar, getCurrentAttire);

    // Get championships
    if (!scenarioInformation && includeChampionships) {
        superstarData["championships"] = [];

        // Load championships if not present
        if (!superstarChampionships) {
            superstarChampionships = await getSuperstarChampionships(superstar);
            // Get freebird championships
            superstarChampionships.push(...await getSuperstarFreebirdTagChampionships(superstar));
        }

        // Get unique championships and sort
        superstarChampionships = getUniqueChampionships(superstarChampionships);
        superstarChampionships.sort(compareChampionships);

        // Get data for championships
        for (const c of superstarChampionships) {
            let d = {};
            d["name"] = c.name;
            d["prestige"] = c.prestige;
            d["matchContract"] = c.matchContract;
            if (c.championshipContract && !c.tagTeam) {
                d["championshipContract"] = true;
                d["championshipUid"] = c.$loki;
            }
            if (c.matchContract) {
                d["matchContract"] = true;
                // Find match contract
                let matchContract = await getChampionshipMatchContract(c);
                if (matchContract) {
                    d['event'] = (await getMatchContractEvent(matchContract))?.name;
                }
            }
            const reign = await getChampionshipCurrentReign(c);
            if (reign && game) {
                d['reignLength'] = getChampionshipReignLength(reign, game.monthCount, game.year);
            }
            superstarData["championships"].push(d);
        }

        // Get graphic with championships
        if (superstarData["graphic"] && superstarChampionships.length > 0) {
            superstarData["graphic"]["title"] = JSON.parse(JSON.stringify(superstarChampionships[0].graphic));
        }
    }

    // Get teams and factions
    if (getTeamsAndFactions) {

        // Get if passed as argument
        let superstarTagTeams;
        let superstarFactions;
        if (superstarTagTeamsAndFactions) {
            superstarTagTeams = superstarTagTeamsAndFactions.filter(x => x.objectName === 'tagTeam');
            superstarFactions = superstarTagTeamsAndFactions.filter(x => x.objectName === 'faction');
        }
        // Otherwise load from database
        else {
            superstarTagTeams = (await getSuperstarTagTeams(superstar)).filter(x => !x.temporary);
            superstarFactions = await getSuperstarActiveFactions(superstar);
        }

        superstarData['teams'] = superstarTagTeams.map(x => x.name);
        superstarData['factions'] = superstarFactions.map(x => x.name);

        if (getTagTeamPartners) {
            superstarData['teamSuperstars'] = [];
            for (let tagTeam of superstarTagTeams) {
                if (!tagTeam.temporary) {
                    let members = await getTagTeamSuperstars(tagTeam);
                    for (let member of members) {
                        if (member.$loki !== superstar.$loki) {
                            superstarData['teamSuperstars'].push(member.name);
                        }
                    }
                }
            }
        }
    }

    // Get gimmick
    if (getGimmick) {
        const superstarGimmick = await getSuperstarCurrentGimmick(superstar);
        if (superstarGimmick) {
            superstarData['gimmick'] = getGimmickData(superstarGimmick, superstar)
        }
    }

    // Get status
    if (superstar.fullTimeManager) {
        superstarData['status'] = 'Manager'
    }
    else {
        if (superstar.partTimer) {
            superstarData['status'] = 'Part-timer'
        }
        else if (superstar.retired) {
            superstarData['status'] = 'Retired'
        }
        else {
            superstarData['status'] = 'Full-time'
        }
    }

    superstarData['uid'] = superstar.$loki;

    if (rosterSuperstars) {
        // Get manager names
        if (managersUsed) {
            manager = await getSuperstarManagerUsedForMatchOrSegment(superstar, managersUsed, rosterSuperstars)
        }
        else {
            manager = rosterSuperstars.find(y => y.$loki === superstar.managerId);
            if (!manager) {
                manager = await getSuperstarManager(superstar)
            }
        }

        if (manager) {
            superstarData['managerNames'] = [manager.name];
        }

        // Get managed talent names
        const managedTalent = await getManagerManagedTalent(superstar, rosterSuperstars, false,
            managedSuperstars);
        superstarData['managedTalentNames'] = managedTalent.map(x => x.name);
    }

    // Get tournaments won
    if (!scenarioInformation && getTournamentsWon) {
        superstarData['tournamentsWon'] = [];
        for (let tournament of await getSuperstarWonTournaments(superstar)) {
            let tournamentEvent = await getTournamentEvent(tournament);
            superstarData['tournamentsWon'].push(`${tournament.name} ${tournamentEvent ? tournamentEvent.year : ''}`);
        }
    }

    return superstarData;
}

function getCanUnlearnTraitsForSuperstar(superstar) {  // get_can_unlearn_traits_for_superstar
    return superstar.traits.filter(x => checkIfCanUnlearnTrait(x));
}

function checkIfCanUnlearnTrait(trait) {  // check_if_can_unlearn_trait
    const traitData = traitsData[trait];
    if (traitData) {
        return traitData['can_unlearn']
    }
    return false
}

async function getSuperstarFreebirdTagChampionships(superstar, companyChampionships = null,
                                                    superstarTagTeams = null) {  // get_superstar_freebird_tag_championships
    let championships = [];
    if (!superstarTagTeams) {
        superstarTagTeams = await getSuperstarTagTeams(superstar)
    }
    let superstarTrio = superstarTagTeams.find(x => x.trio && !x.temporary);
    if (superstarTrio) {
        // Get superstar championships
        const tagChampionshipsAll = [];
        for (const s of await getTagTeamSuperstars(superstarTrio)) {
            let superstarChampionships;
            if (companyChampionships) {
                superstarChampionships = companyChampionships.filter(x => x.superstarId === s.$loki && x.tagTeam);
            }
            else {
                superstarChampionships = (await getSuperstarChampionships(s)).filter(x => x.tagTeam)
            }
            tagChampionshipsAll.push(...superstarChampionships);
        }

        // Get title sets
        const tagChampionships = getUniqueChampionships(tagChampionshipsAll);
        for (const y of tagChampionships) {
            const championshipsSets = tagChampionshipsAll.filter(x => checkAreChampionshipsEqual(x, y));
            // Check if all sets present in team superstars
            if (championshipsSets.length === 2) {
                championships.push(y)
            }
        }
    }
    return championships;
}

function getGimmickData(gimmick, superstar) {  // get_gimmick_data
    let data = {};
    data['name'] = gimmick.name;
    data['effectiveness'] = gimmick.effectiveness;
    data['combinationResult'] = getGimmickCombinationResult(gimmick.combinationBonus);
    data['superstar'] = superstar.name;
    if (gimmick.startMonth) {
        data['startMonths'] = gimmick.startMonth * 12 + gimmick.startYear
    }
    if (gimmick.endMonth) {
        data['endMonths'] = gimmick.endMonth * 12 + gimmick.endYear
    }
    return data;
}

function getGimmickCombinationResult(value) {  // get_gimmick_combination_result
    if (value > 0) {
        return 'easy'
    }
    else if (value < 0) {
        return 'hard'
    }
    return 'okay'
}

async function getSuperstarMatchOrSegmentData(superstar, matchChampionships, managersUsed, rosterSuperstars = null) {  // Previously get_superstar_match_data
    let championshipSuperstarIds = matchChampionships.map(x => x.superstarId);
    let manager = await getSuperstarManagerUsedForMatchOrSegment(superstar, managersUsed, rosterSuperstars);
    return {
        "name": superstar.name,
        "champion": championshipSuperstarIds.indexOf(superstar.$loki) >= 0,
        "uid": superstar.$loki,
        "currentAttire": superstar.currentAttire,
        "alternateAttires": (superstar.graphic && superstar.graphic.alternate_attires && superstar.graphic.alternate_attires.length > 0) ?
            superstar.graphic.alternate_attires.length : null,
        "managerName": manager ? manager.name : null
    }
}

async function getSuperstarManagerUsedForMatchOrSegment(superstar, managersUsed, rosterSuperstars = null) {  // Previously get_superstar_manager_used_for_match_or_segment
    // Get manager from roster superstars to reduce queries to Superstar
    if (managersUsed !== null) {
        const managerId = managersUsed[String(superstar.$loki)];
        if (managerId) {
            let manager;
            if (rosterSuperstars) {
                manager = rosterSuperstars.find(x => x.$loki === managerId);
            }
            if (!manager) {
                manager = await Superstars.get(managerId);
            }
            return manager;
        }
    }
    return null;
}

async function getRosterMemberSuperstars(rosterMember) {
    if (rosterMember.objectName === 'superstar')
        return [rosterMember];
    else if (rosterMember.objectName === 'tagTeam') {
        return getTagTeamSuperstars(rosterMember);
    }
    else if (rosterMember.objectName === 'faction') {
        return getFactionSuperstars(rosterMember);
    }
}

function getGraphicForSuperstar(superstar, getCurrentAttire = false) {
    // Get superstar's graphic with uid
    let graphic = superstar.graphic ? JSON.parse(JSON.stringify(superstar.graphic)) : null;
    if (getCurrentAttire && superstar.currentAttire > 0 && graphic && graphic['alternate_attires']) {
        graphic = graphic['alternate_attires'][superstar.currentAttire - 1]
    }
    if (!graphic || Object.keys(graphic).length === 0) {
        // Get empty graphic if none present
        graphic = getEmptySuperstarGraphic(superstar)
    }
    graphic["uid"] = superstar.$loki;
    return graphic;
}

function getEmptySuperstarGraphic(superstar) {  // get_empty_superstar_graphic
    const emptyMaleGraphic = {
        'empty_graphic': true, 'body': {'colors': ['0x4D4D4D'], 'object': 0},
        'tattoo': {'colors': null, 'object': -1}, 'eyes': {'colors': ['0x353535'], 'object': 0},
        'facepaint': {'colors': null, 'object': -1},
        'shoes': {'colors': ['0x1B1B1B'], 'object': -1},
        'accessory2': {'colors': null, 'object': -1}, 'accessory3': {'colors': null, 'object': -1},
        'alternate_attires': [], 'facialHair': {'colors': null, 'object': -1},
        'accessory': {'colors': null, 'object': -1}, 'hair': {'colors': ['0x71645F'], 'object': 0},
        'bottoms': {'colors': ['0x333333'], 'object': -1}, 'elbow': {'colors': null, 'object': -1},
        'knee': {'colors': null, 'object': -1}, 'torso': {'colors': null, 'object': -1}
    };
    const emptyFemaleGraphic = {
        'empty_graphic': true, 'body': {'colors': ['0x4D4D4D'], 'object': 3},
        'tattoo': {'colors': null, 'object': -1}, 'eyes': {'colors': ['0x353535'], 'object': 0},
        'facepaint': {'colors': null, 'object': -1},
        'shoes': {'colors': ['0x1B1B1B'], 'object': -1},
        'accessory2': {'colors': null, 'object': -1},
        'accessory3': {'colors': null, 'object': -1}, 'alternate_attires': [],
        'facialHair': {'colors': null, 'object': -1}, 'accessory': {'colors': null, 'object': -1},
        'hair': {'colors': ['0x71645F'], 'object': 0},
        'bottoms': {'colors': ['0x333333'], 'object': -1},
        'elbow': {'colors': null, 'object': -1}, 'knee': {'colors': null, 'object': -1},
        'torso': {'colors': null, 'object': -1}
    };
    if (superstar.gender === 'male') {
        return JSON.parse(JSON.stringify((emptyMaleGraphic)))
    }
    else if (superstar.gender === 'female') {
        return JSON.parse(JSON.stringify((emptyFemaleGraphic)))
    }
    else {
        return JSON.parse(JSON.stringify((emptyMaleGraphic)))
    }
}

function getSuperstarGenderFromPronoun(pronoun) {  // Previously get_superstar_gender_from_pronoun
    if (pronoun === 'he') {
        return 'male'
    }
    else if (pronoun === 'she') {
        return 'female'
    }
    return 'non-binary';
}

function checkSuperstarGraphicMask(graphic) {  // Previously check_superstar_graphic_mask
    if (!graphic) {
        return false;
    }

    const accessoriesData = graphicsData['accessories'];
    const facepaintsData = graphicsData['facepaints'];
    let maskFound = false;

    for (const [key, value] of Object.entries(graphic)) {
        if (['accessory', 'accessory2', 'accessory3'].indexOf(key) >= 0) {
            try {
                if (accessoriesData[value['object']]['category'] === 'mask') {
                    maskFound = true;
                    break;
                }
            }
            catch {}
        }
        else if (key === 'facepaint') {
            try {
                if (facepaintsData[value['object']]['category'] === 'mask') {
                    maskFound = true;
                    break;
                }
            }
            catch {}
        }
    }

    return maskFound;
}

function getSuperstarChampionshipsFromCompanyChampionships(superstar, companyChampionships) {  // get_superstar_championships_from_all_championships
    return getUniqueChampionships(companyChampionships.filter(x => x.superstarId === superstar.$loki));
}

async function getSuperstarActiveFactions(superstar) {  // get_superstar_active_factions
    return (await getSuperstarFactions(superstar)).filter(x => !x.disbanded);
}

function changeSuperstarMoraleToHappy(superstar) {  // change_superstar_morale_to_happy
    superstar.unhappy = false;
    superstar.morale = 85;
    superstar.contractMonthsRemaining = null;
    return superstar
}

async function changeSuperstarMoraleToUnhappy(superstar, company) {  // change_superstar_morale_to_unhappy
    superstar.unhappy = true;
    superstar.morale = 15;
    if (company.userControlled) {
        const newCompanyAlert = await createCompanyAlert('unhappy', superstar.name);
        await addCompanyCompanyAlerts(company, [newCompanyAlert]);
    }
    return superstar
}

async function removeSuperstarFactionRelationships(superstar, month, year) {  // process_superstar_leaving_factions
    const disbandedFactions = [];
    const superstarFactions = [...await getSuperstarFactions(superstar)];

    for (const faction of superstarFactions) {
        // Update faction rep (members)
        await processFactionXpChangeForFaction({faction, removedMembers: [superstar]});
        await removeSuperstarsFromFaction(faction, [superstar]);
        const factionSuperstars = await getFactionSuperstars(faction);
        if (factionSuperstars.length < 2) {
            await disbandFaction(faction, month, year);
            disbandedFactions.push(faction.name);
        }
    }

    return disbandedFactions;
}

async function removeSuperstarManagerRelationships(superstar) {  // process_superstar_leaving_managers
    // Remove manager
    const manager = await getSuperstarManager(superstar);
    if (manager) {
        await removeSuperstarsFromManager(manager, [superstar])
    }

    // Remove managed superstars
    const managedSuperstars = await getSuperstarManagedSuperstars(superstar);
    if (managedSuperstars.length > 0) {
        await removeSuperstarsFromManager(superstar, managedSuperstars)
    }
    return true;
}

async function removeSuperstarsFromManager(manager, superstars) {
    const managedSuperstars = await getSuperstarManagedSuperstars(manager);
    for (const superstar of [...superstars]) {
        if (objectInArray(superstar, managedSuperstars)) {
            removeSuperstarManager(superstar)
        }
    }
    return true;
}

async function addSuperstarsToManager(manager, superstars) {  // add_superstars_to_manager
    const managedSuperstars = await getSuperstarManagedSuperstars(manager);
    for (const superstar of superstars) {
        if (!objectInArray(superstar, managedSuperstars)) {
            await setSuperstarManager(superstar, manager)
        }
    }
    return true;
}

async function removeSuperstarTagTeams(superstar) {  // remove_superstar_tag_teams
    const data = [];
    const superstarTagTeams = await getSuperstarTagTeams(superstar);
    for (const tagTeam of superstarTagTeams) {
        if (!tagTeam.temporary) {
            data.push(tagTeam.name)
        }
        await removeTagTeam(tagTeam)
    }
    return data;
}

function endSuperstarInjury(superstar) {  // end_superstar_injury
    superstar.readyToReturn = true;
    superstar.workableInjury = false;
    return true;
}

function updateSuperstarMorale(superstar, change) {  // update_superstar_morale
    superstar.morale += change;
    superstar.morale = limitValueBetweenRange(superstar.morale, 0, 100);
    return superstar.morale;
}

async function getSuperstarChampionshipsToVacate(superstar, tagTeam = null) {  // get_superstar_championships_to_vacate
    let championshipsToVacate = await getSuperstarChampionships(superstar);
    if (tagTeam) {
        if (tagTeam.trio) {
            championshipsToVacate = championshipsToVacate.filter(x => x.trio || x.tagTeam)
        }
        else {
            championshipsToVacate = championshipsToVacate.filter(x => x.tagTeam)
        }
    }

    return championshipsToVacate;
}

function getSuperstarLastName(superstar) {  // get_superstar_last_name
    let names = superstar.name.split(' ');
    if (names.length === 2 && names[names.length - 1].length > 2) {
        return names[names.length - 1];
    }
    else {
        return superstar.name;
    }
}

async function changeSuperstarAttire({superstarUid}) {  // _change_superstar_attire
    let data = {};
    let superstar = await Superstars.get(superstarUid);
    data['name'] = superstar.name;

    // Check if graphic present
    if (!superstar.graphic || Object.keys(superstar.graphic).length === 0) {
        data['error'] = 'no-graphic';
        return data;
    }

    // Check if alternate attires present
    let alternateAttires = superstar.graphic['alternate_attires'];
    if (!alternateAttires || alternateAttires.length <= 0) {
        data['error'] = 'no-alternate-attires';
        return data;
    }

    // Set currentAttire to next attire`
    let nextAttire = superstar.currentAttire + 1;
    if (nextAttire > alternateAttires.length) {
        nextAttire = 0
    }
    superstar.currentAttire = nextAttire;

    db.saveDatabase();

    // Get data to return
    data['name'] = superstar.name;
    data['currentAttire'] = superstar.currentAttire;

    return data;
}

function getSuperstarCharisma(superstar) {  // get_participant_charisma
    return superstar.hot ? superstar.charisma + 1 : superstar.charisma;
}

function getSuperstarWorkrate(superstar) {  // get_participant_workrate
    return superstar.hot ? superstar.workrate + 1 : superstar.workrate;
}

function getSuperstarManagerGraphic(manager, participant) {  // get_superstar_manager_graphic
    let graphic = JSON.parse(JSON.stringify(manager.graphic));
    if (!graphic || Object.keys(graphic).length === 0) {
        graphic = getEmptySuperstarGraphic(manager)
    }
    graphic = JSON.parse(JSON.stringify(graphic));
    graphic['isManager'] = true;
    graphic['superstarUid'] = participant.$loki;
    return graphic;
}

function getTraitWeightsForSuperstars(superstars, traitEffect) {  // get_trait_weights_for_superstars
    let weights = [];
    for (const superstar of superstars) {
        let weight = 1;
        for (const trait of superstar.traits) {
            let traitData = traitsData[trait];
            if (traitData && traitData[traitEffect]) {
                weight *= 8
            }
        }
        weights.push([superstar, weight]);
    }
    return weights;
}

async function getKayfabePointsChange({changeType, participants = null, winner = null, win = false, weeklyShow = false,
                                       wonChampionships = null, defendedChampionships = null, match = null} = {}) {  // get_kayfabe_points_change
    let change = 0;
    if (changeType === 'matchResult') {
        change = await getKayfabePointsChangeForMatchResult(participants, winner, win, weeklyShow, match);
    }
    if (changeType === 'mainEvent') {
        change = getKayfabePointsChangeForMainEvent(weeklyShow);
    }
    if (changeType === 'championships') {
        change = getKayfabePointsChangeForChampionships(wonChampionships, defendedChampionships);
    }
    if (changeType === 'fotc') {
        change = 30;
    }
    if (changeType === 'holyShitMoment') {
        change = 8;
    }

    return Math.floor(change);
}

async function getKayfabePointsChangeForMatchResult(participants, winner, win, weeklyShow, match) {  // get_kayfabe_points_change_for_match_result
    const ranks = {'Main Eventer': 3, 'Upper Midcarder': 2, 'Lower Midcarder': 1, 'Jabroni': 0};
    // Get win/loss change
    let change = 15;
    if (weeklyShow) {
        change = 5;
    }
    if (!win) {
        change *= -1;
    }

    for (const x of participants) {
        x.tempPopularity = await getRosterMemberPopularity(x, x.tempSuperstars);  // add to get max, remove below
    }

    // Get change based on ranks and fotc
    let losers = participants.filter(x => x.$loki !== winner.$loki);
    const opponentToUse = win ? getArrayMaxByProperty(losers, 'tempPopularity') : winner;
    const opponentIsFotc = (await getRosterMemberSuperstars(opponentToUse)).every(x => x.faceOfTheCompany);
    let rankChange = opponentIsFotc ? 4 : ranks[getRankFromPopularity(opponentToUse.tempPopularity)] || 0;
    if (!weeklyShow) {
        rankChange *= 2;
    }
    change += rankChange;

    // Divide loss by number of opponents
    if (!win) {
        const numberOfOpponents = participants.length - 1;
        if (numberOfOpponents > 0) {
            change /= numberOfOpponents;
        }
    }

    // Add high rating boost
    if (match.rating >= 5) {
        change += 20;
    }

    for (const x of participants) {
        delete x.tempPopularity;
    }

    return change;
}

function getKayfabePointsChangeForMainEvent(weeklyShow) {  // get_kayfabe_points_change_for_main_event
    let change;
    if (weeklyShow) {
        change = 4;
    } else {
        change = 12;
    }
    return change;
}

function getKayfabePointsChangeForChampionships(wonChampionships, defendedChampionships) {  // get_kayfabe_points_change_for_championships
    const championshipsWins = {'S': 20, 'A': 15, 'B': 8, 'C': 3};
    const championshipsDefences = {'S': 12, 'A': 9, 'B': 5, 'C': 2};
    let change = 0;
    for (let championship of wonChampionships) {
        change += championshipsWins[championship.prestige];
    }
    for (let championship of defendedChampionships) {
        change += championshipsDefences[championship.prestige];
    }
    return change;
}

function updateSuperstarKayfabePoints(superstar, change) {  // update_superstar_kayfabe_points
    superstar.kayfabePoints += change;
    superstar.kayfabePointsTemporary += change;
    return superstar.kayfabePointsTemporary;
}

async function checkAcquireTrait(superstar, trait, gimmickMatchName = null) {  // check_acquire_trait
    if (!(await getSuperstarRoster(superstar))) {
        return false;
    }
    if (!globalUser.paid) {
        return false;
    }

    // Check if trait is acquirable
    const traitData = traitsData[trait];
    if (traitData && traitData['acquirable']) {
        // Check trait requirements
        const requirementCheck = checkAcquireTraitRequirement(superstar, trait);
        if (requirementCheck) {
            // Set gimmick match expert trait if present
            if (trait === "Match Expert" && gimmickMatchName) {
                trait = `${gimmickMatchName} ${trait}`;
            }

            // Check if trait is not present and doesn't conflict
            const superstarTraits = [...superstar.traits];
            const conflictingTraits = [];
            for (const s of superstarTraits) {
                conflictingTraits.push(...traitsData[formatSuperstarTrait(s)]['conflicting_traits']);
            }
            // Format trait so that match expert sends in 'Match Expert' for conflicting traits check
            if (!superstarTraits.includes(trait) && !conflictingTraits.includes(formatSuperstarTrait(trait))) {

                // Add trait progress
                const traitProgressIncrease = traitData['progress_per_action'];
                if (superstar.traitsProgress[trait]) {
                    superstar.traitsProgress[trait] += traitProgressIncrease;
                } else {
                    superstar.traitsProgress[trait] = traitProgressIncrease;
                }

                // Check if minimum progress achieved, random chance to add trait based on trait progress
                const traitProgress = superstar.traitsProgress[trait];
                if (traitProgress >= traitData['minimum_progress_to_acquire'] &&
                    getRandomInt(0, 100) <= traitProgress) {
                    addTraitToSuperstar(superstar, trait);

                    // Remove trait progress
                    delete superstar.traitsProgress[trait];

                    // Add trait acquired message
                    const talentCompany = await getTalentCompany(superstar);
                    if (talentCompany && talentCompany.userControlled) {
                        const newMessage = await createTraitAcquiredMessage(superstar, trait, talentCompany);
                        await addCompanyMessages(talentCompany, [newMessage]);
                    }
                }
            }
        }
    }

    return true;
}

function addTraitToSuperstar(superstar, trait) {  // add_trait_to_superstar
    if (!(superstar.traits.includes(trait))) {
        superstar.traits.push(trait)
    }
    return superstar.traits;
}

function formatSuperstarTrait(trait) {  // format_superstar_trait
    if (trait.includes('Match Expert')) {
        return 'Match Expert';
    }
    return trait;
}

function checkAcquireTraitRequirement(superstar, trait) {  // check_acquire_trait_requirement
    function checkTraitRequirementWorkrate(value, operator) {
        if (operator === ">=") {
            if (superstar.workrate >= value) {
                return true;
            }
        } else if (operator === "<=") {
            if (superstar.workrate <= value) {
                return true;
            }
        }
        return false;
    }

    function checkTraitRequirementCharisma(value, operator) {
        if (operator === ">=") {
            if (superstar.charisma >= value) {
                return true;
            }
        } else if (operator === "<=") {
            if (superstar.charisma <= value) {
                return true;
            }
        }
        return false;
    }

    function checkTraitRequirementTrait(value) {
        return superstar.traits.includes(value);

    }

    function checkTraitRequirementWorkrate3StarsOrHigher() {
        return checkTraitRequirementWorkrate(3, ">=")
    }

    function checkTraitRequirementWorkrate2StarsOrHigher() {
        return checkTraitRequirementWorkrate(2, ">=")
    }

    function checkTraitRequirementWorkrate2StarsOrLower() {
        return checkTraitRequirementWorkrate(2, "<=")
    }

    function checkTraitRequirementWorkrate1StarOrLower() {
        return checkTraitRequirementWorkrate(1, "<=")
    }

    function checkTraitRequirementCharisma3StarsOrHigher() {
        return checkTraitRequirementCharisma(3, ">=")
    }

    function checkTraitRequirementDedicatedWrestlerTraitPresent() {
        return checkTraitRequirementTrait("Dedicated Wrestler")
    }

    // Dictionary of check functions
    const checkFunctions = {
        "3*_workrate": checkTraitRequirementWorkrate3StarsOrHigher,
        "2*_workrate_or_higher": checkTraitRequirementWorkrate2StarsOrHigher,
        "2*_workrate_or_lower": checkTraitRequirementWorkrate2StarsOrLower,
        "1*_workrate": checkTraitRequirementWorkrate1StarOrLower,
        "3*_charisma": checkTraitRequirementCharisma3StarsOrHigher,
        "dedicated_wrestler_trait_present": checkTraitRequirementDedicatedWrestlerTraitPresent,
    };

    for (const requirement of traitsData[trait]['requirements_to_acquire']) {
        const checkFunction = checkFunctions[requirement];
        if (checkFunction && !checkFunction()) {
            return false;
        }
    }

    return true;
}

async function debutGimmick(superstar, company, producer, month = null, year = null) {
    const superstarGimmicks = (await getSuperstarGimmicks(superstar)).reverse();
    const game = await getCompanyGame(company);

    // Add effectiveness, start month/year
    const gimmick = superstarGimmicks[0];
    const [effectiveness, productionBoost] = getGimmickEffectiveness(superstar, gimmick, producer);
    gimmick.effectiveness = effectiveness;
    gimmick.startMonth = month;
    gimmick.startYear = year;

    // End previous gimmick
    let oldGimmickEffect = 0;
    if (superstarGimmicks.length > 1) {
        const oldGimmick = superstarGimmicks[1];
        oldGimmick.endMonth = month;
        oldGimmick.endYear = year;

        // Undo previous gimmick's overness effect
        oldGimmickEffect = getGimmickEffectivenessEffect(oldGimmick.effectiveness);
        superstar.overness -= oldGimmickEffect;
    }

    // Add new gimmick's overness effect
    const newGimmickEffect = getGimmickEffectivenessEffect(gimmick.effectiveness);
    superstar.overness += newGimmickEffect;
    superstar.debutNewGimmick = false;

    const data = getGimmickData(gimmick, superstar);
    data['overnessEffectChange'] = newGimmickEffect - oldGimmickEffect;
    data['productionBoost'] = productionBoost;

    // Add xp to producer
    if (producer) {
        const ageMultiplier = getStaffAgeMultiplier(producer);
        const xpGained = Math.round(5 * ageMultiplier);
        const producerLevelIncrease = await updateStaffMemberXp(producer, xpGained, company, game);
        if (producerLevelIncrease) {
            data['staffSkillIncreases'] = {'name': producer.name, 'level': producer.level, 'role': producer.role};
        }
    }

    // Check talent request
    const talentCompany = await getTalentCompany(superstar);
    if (talentCompany) {
        await checkTalentRequestAction({company: talentCompany, requestType: 'debut_new_gimmick', talent: superstar});
    }

    return data;
}

function getGimmickEffectiveness(superstar, gimmick, producer) {  // get_gimmick_effectiveness
    const charisma = superstar.hot ? superstar.charisma + 1 : superstar.charisma;
    const combinationBase = 15;
    const charismaMultiplier = 14.5;
    let minimumValue, maximumValue;

    if (gimmick.combinationBonus === 10) {
        minimumValue = combinationBase;
        maximumValue = combinationBase * 2;
    } else if (gimmick.combinationBonus === 0) {
        minimumValue = 0;
        maximumValue = combinationBase;
    } else {
        minimumValue = combinationBase * -1;
        maximumValue = 0;
    }
    minimumValue += (charisma ** 1.35) * charismaMultiplier;
    maximumValue += (charisma ** 1.35) * charismaMultiplier;

    // Get trait boost for gimmick character
    let traitBoost = 0;
    if (gimmick.character) {
        let gimmickCharacterData = charactersData.find(x => x['name'] === gimmick.character);
        if (gimmickCharacterData) {
            for (const trait of superstar.traits) {
                const traitData = traitsData[trait];
                if (gimmickCharacterData['tag'] === 'fantasy') {
                    if (traitData && traitData['fantasy_gimmick_character_boost']) {
                        traitBoost += traitData['fantasy_gimmick_character_boost'];
                    }
                }
                if (gimmickCharacterData['tag'] !== 'fantasy') {
                    if (traitData && traitData['non_fantasy_gimmick_character_boost']) {
                        traitBoost += traitData['non_fantasy_gimmick_character_boost'];
                    }
                }
                if (traitData && traitData['gimmick_boost']) {
                    traitBoost += traitData['gimmick_boost'];
                }
                if (gimmick.combinationBonus <= -10) { // Bad combination
                    if (traitData && traitData['bad_combination_gimmick_boost']) {
                        traitBoost += traitData['bad_combination_gimmick_boost'];
                    }
                }
            }
        }
    }
    traitBoost = limitValueBetweenRange(traitBoost, -40, 20);

    let startingEffectiveness = Math.floor(getRandomUniform(minimumValue, maximumValue)) +
        gimmick.characterBonus + traitBoost;

    // Add producer multiplier
    const producerMultipliers = {1: 0, 2: 8, 3: 15};
    const producerLevel = producer ? producer.level : 1;
    let producerBoost = producerMultipliers[producerLevel] || 0;
    if (producerBoost) {
        producerBoost += getRandomInt(-2, 2);
    }
    let effectiveness = startingEffectiveness + producerBoost;

    // Limit effectiveness between 0 and 100
    effectiveness = limitValueBetweenRange(effectiveness, 0, 100);

    return [effectiveness, producerBoost];
}


async function checkForSuperstarInjury(superstar, matchParticipants, opponentSuperstars, matchGimmick, holyShitData,
                                       tournament, company, game) {
    // Defaults
    let injuryMonths = 0;
    let injuryName = null;
    let injuryType = null;
    let injuryChance = null;

    // Don't check injury if turned off in sandbox mode
    if (game.settings['no_injuries']) {
        return {'months': injuryMonths, 'type': injuryType, 'chance': injuryChance, 'name': injuryName};
    }

    // Don't let cyborgs get injured
    if (superstar.cyborg) {
        return {'months': injuryMonths, 'type': injuryType, 'chance': injuryChance, 'name': injuryName};
    }

    if (company) {
        // Don't let stars get injured in POW
        if (company.storyName === 'passion' && ['Lady Julia', 'Violet', 'Natasha Ali', 'Zora'].includes(superstar.name)) {
            return {'months': injuryMonths, 'type': injuryType, 'chance': injuryChance, 'name': injuryName};
        }

        if (company.storyName === 'tutorial') {
            // Force injury
            let tutorialState = await getTutorialStateName(company);
            if (tutorialState === 'play_first_event' && superstar.name === 'Chris Gray') {
                injuryMonths = 6;
                injuryType = 'minor';
                injuryName = getRandomChoice(injuriesData[injuryType]['names']);
                return {'months': injuryMonths, 'type': injuryType, 'chance': injuryChance, 'name': injuryName};
            }
            // Don't check injury until tutorial ends
            else if (tutorialState !== 'end_tutorial') {
                return {'months': injuryMonths, 'type': injuryType, 'chance': injuryChance, 'name': injuryName};
            }
        }
    }

    // Get injury chance
    injuryChance = await getSuperstarInjuryChance(superstar, matchParticipants, opponentSuperstars, matchGimmick,
        holyShitData, tournament, company, game);

    // Check for injury
    if (getRandomUniform(0, 100) <= injuryChance) {
        [injuryMonths, injuryName, injuryType] = getInjuryDetails(superstar, game);
    }

    return {'months': injuryMonths, 'type': injuryType, 'chance': injuryChance, 'name': injuryName};
}

async function getSuperstarInjuryChance(superstar, matchParticipants, opponentSuperstars, matchGimmick,
                                        holyShitData, tournament, company, game) {  // get_superstar_injury_chance
    // Injury chance is a percentage

    // Set default value
    let injuryChance = 1.0;

    // Increase by match gimmick's injury rate
    if (matchGimmick) {
        injuryChance *= matchGimmick.injuryRate;
    }

    // Increase for holy shit moment
    if (holyShitData) {
        injuryChance *= 1.4;
    }

    // Slight increase for pure companies
    if (company && company.style === 'pure') {
        injuryChance += 0.1;
    }

    // Decrease injury chance by tournament rounds
    if (tournament) {
        injuryChance /= tournament.rounds;
    }

    // Decrease injury chance by number of superstars
    let matchSuperstars = (await Promise.all(matchParticipants.map(x => getRosterMemberSuperstars(x)))).flat();
    const numberOfSuperstars = matchSuperstars.length;
    injuryChance /= numberOfSuperstars * 0.5;

    // Get injury chance trait multiplier, increase superstar injury chance if found
    for (const trait of superstar.traits) {
        const traitData = traitsData[trait];
        if (traitData && traitData['injury_chance_multiplier']) {
            injuryChance *= traitData['injury_chance_multiplier'];
        }
    }

    // Get dangerous worker trait from opponent superstars, increase superstar injury chance if found
    let superstarInjuryChanceMultiplier = 1;
    for (const opponentSuperstar of opponentSuperstars) {
        for (const trait of opponentSuperstar.traits) {
            const traitData = traitsData[trait];
            if (traitData && traitData['cause_injury_chance_multiplier']) {
                superstarInjuryChanceMultiplier = traitData['cause_injury_chance_multiplier'];
            }
        }
    }
    injuryChance *= superstarInjuryChanceMultiplier;

    // Add fatigue effect if enabled
    if (game.settings['enable_fatigue'] !== false) {
        injuryChance *= getFatigueInjuryChance(superstar);
    }

    // Add workable injury chance
    if (superstar.workableInjury) {
        injuryChance += 15;
    }

    // Decrease chance of multiple injuries in a period
    if (company) {
        const injuries3Months = (await getCompanyCompanyLogs(company)).filter(x => x.type === 'injury'
            && x.value !== 0 && getMonthsDifference(game.monthCount, game.year, x.month, x.year) <= 3);
        if (injuries3Months.length >= 3) {
            injuryChance *= 0.6;
        }
    }

    // Limit value
    injuryChance = limitValueBetweenRange(injuryChance, 0, 30);

    return injuryChance;
}

function getFatigueInjuryChance(superstar) {  // get_fatigue_injury_chance
    // Injury chance rises exponentially with fatigue, from 0.5% to 20%
    return ((1.055 ** (superstar.fatigue / 1.15) / 4.2) + 0.25);
}

function getInjuryDetails(superstar, game) {  // get_injury_details
    // Returns injury months, name and type
    let injuryType = null;
    let injuryName = null;
    let injuryMonths = null;

    // Get severe version of workable injury
    if (superstar.workableInjury) {
        injuryName = injuriesData['workable']['severe_versions'][superstar.injuryName];
        injuryType = Object.keys(injuriesData).find((k) => injuriesData[k]['names'].includes(injuryName));
        if (injuryType) {
            const injuryData = injuriesData[injuryType];
            injuryMonths = getRandomInt(injuryData['months_min'], injuryData['months_max']);
        }
    }

    // Get random injury if not working through injury or severe version not found
    if (!injuryType) {
        // Get injury type from chances
        injuryType = weightedChoice(getInjuryTypeChances(superstar, game));

        // Get injury name and months
        const injuryData = injuriesData[injuryType];
        injuryName = getRandomChoice(injuryData['names']);
        injuryMonths = getRandomInt(injuryData['months_min'], injuryData['months_max']);
    }

    return [injuryMonths, injuryName, injuryType];
}

function getInjuryTypeChances(superstar, game) {  // get_injury_type_chances
    // Get workable injury chance
    const workableInjuryChance = getWorkableInjuryChance(superstar, game);
    let remainingChance = 100 - workableInjuryChance;

    // Get major/minor injury chances. Major vs minor injury chance is 1:3.
    let majorInjuryChance = Math.floor(1 / 4.0 * remainingChance);
    let minorInjuryChance = remainingChance - majorInjuryChance;

    return [['workable', workableInjuryChance], ['minor', minorInjuryChance], ['major', majorInjuryChance]];
}

function getWorkableInjuryChance(superstar, game) {  // get_workable_injury_chance
    // Fatigue affects chance, low fatigue is more likely to cause workable injury
    let workableInjuryChance;
    if (game.settings['enable_fatigue'] !== false) {
        if (superstar.fatigue > 80) {
            workableInjuryChance = 5;
        } else if (superstar.fatigue > 40) {
            workableInjuryChance = 20;
        } else {
            workableInjuryChance = 30;
        }
    }
    // Chance if fatigue is disabled
    else {
        workableInjuryChance = 25;
    }

    return workableInjuryChance;
}

async function addInjuryToSuperstar(superstar, injuryMonths, injuryName, injuryType, company) {  // add_injury_to_superstar
    superstar.injured += injuryMonths;
    superstar.injuryName = injuryName;
    superstar.injuredAtLatestShow = true;
    superstar.workableInjury = injuryType === 'workable';

    // Check talent request
    if (company) {
        await checkTalentRequestAction({company: company, requestType: 'write_off', talent: superstar});
    }

    return true;
}

function addKayfabeInjuryToSuperstar(superstar, injuryMonths) {  // add_kayfabe_injury_to_superstar
    if (superstar.workableInjury) {
        superstar.injured = injuryMonths
    }
    else {
        superstar.injured += injuryMonths
    }
    superstar.workableInjury = false;
    superstar.injuryName = null;
    superstar.injuryReturnMin = superstar.injured;
    superstar.injuryReturnMax = superstar.injured + 1;
    return true;
}

function checkSuperstarWorkThroughInjury(superstar) {  // check_superstar_work_through_injury
    const workThroughInjuryTraits = ['Workhorse', 'Dedicated Wrestler', 'Lifelong Wrestler', 'Loyal'];
    return workThroughInjuryTraits.some(x => superstar.traits.includes(x));
}

async function addNextGimmickBoost(superstar, chance = 20) {  // add_next_gimmick_boost
    if (getRandomInt(0, 100) <= chance) {
        const superstarGimmick = await getSuperstarCurrentGimmick(superstar);
        if (superstarGimmick) {
            superstarGimmick.nextGimmickBoost = true;
            return true;
        }
    }
    return false;
}

function removeSuperstarGraphicHair(graphic) {  // remove_superstar_graphic_hair
    // Remove hair
    graphic = JSON.parse(JSON.stringify(graphic));
    if (graphic['hair']) {
        graphic['hair']['object'] = 0;
    }

    // Remove hair on alternate attires
    const alternateAttires = graphic.alternate_attires;
    if (alternateAttires) {
        const newAlternateAttires = [];
        for (const alt of alternateAttires) {
            let altGraphic = JSON.parse(JSON.stringify(alt));
            altGraphic.hair.object = 0;
            newAlternateAttires.push(altGraphic);
        }
        graphic.alternate_attires = newAlternateAttires;
    }

    return graphic;
}

function removeSuperstarGraphicMask(graphic) {  // remove_superstar_graphic_mask
    let accessoriesData = graphicsData['accessories'];
    let facepaintsData = graphicsData['facepaints'];

    for (const [k, v] of Object.entries(graphic)) {
        let remove = false;
        if (['accessory', 'accessory2', 'accessory3'].includes(k)) {
            try {
                if (accessoriesData[v['object']]['category'] === 'mask') {
                    remove = true
                }
            }
            catch {}
        }
        if (['facepaint'].includes(k)) {
            try {
                if (facepaintsData[v['object']]['category'] === 'mask') {
                    remove = true
                }
            }
            catch {}
        }
        if (remove) {
            // Remove mask
            graphic = JSON.parse(JSON.stringify(graphic));
            graphic[k]['object'] = -1;

            // Remove mask on alternate attires
            const alternateAttires = graphic.alternate_attires;
            if (alternateAttires) {
                const newAlternateAttires = [];
                for (const alt of alternateAttires) {
                    let altGraphic = JSON.parse(JSON.stringify(alt));
                    altGraphic[k]['object'] = -1;
                    newAlternateAttires.push(altGraphic);
                }
                graphic.alternate_attires = newAlternateAttires;
            }
        }
    }
    return graphic;
}

function addSuperstarGraphicHair(graphic, gender) {  // add_superstar_graphic_hair
    graphic = JSON.parse(JSON.stringify(graphic));

    // Select hair
    let hairsChoices = [...graphicsData['hairs']];
    if (gender === 'male' && getRandomInt(0, 100) <= 80) {
        hairsChoices = hairsChoices.filter(x => x['style'] === 'masculine');
    } else if (gender === 'female' && getRandomInt(0, 100) <= 80) {
        hairsChoices = hairsChoices.filter(x => x['style'] === 'feminine');
    }
    const hairObject = getRandomChoice(hairsChoices);
    const hairObjectNumber = hairObject['number'];

    // Select hair color
    let hairColor = null;

    // Get hair color using facial hair color if present
    if (graphic['facialHair']['object'] > 0) {
        hairColor = graphic['facialHair']['colors'][0];
    }

    // Otherwise get new color
    if (!hairColor) {
        hairColor = getHairColor();
    }

    // Add hair colors for each design in hair object
    const hairColors = new Array(hairObject['designs']).fill(hairColor);

    // Add hair
    graphic['hair']['object'] = hairObjectNumber;
    graphic['hair']['colors'] = hairColors;

    // Add hair on alternate attires
    const alternateAttires = graphic.alternate_attires;
    if (alternateAttires) {
        const newAlternateAttires = [];
        for (const alt of alternateAttires) {
            let altGraphic = JSON.parse(JSON.stringify(alt));
            altGraphic['hair']['object'] = hairObjectNumber;
            altGraphic['hair']['colors'] = hairColors;
            newAlternateAttires.push(altGraphic);
        }
        graphic.alternate_attires = newAlternateAttires;
    }

    return graphic;
}

function updateSuperstarFatigue(superstar, change) {  // update_superstar_fatigue
    superstar.fatigue += change;
    return superstar.fatigue;
}

function getSuperstarFatigueChangeForMatch(superstar, matchGimmick, matchParticipants, weeklyShow, matchType,
                                           tournament) {  // get_superstar_fatigue_change_for_match
    // Base change for a superstar per match
    let change = 20;
    if (superstar.age > 40 && !superstar.traits.includes('Ages Well')) {
        // Higher for older superstar
        change = 23;
    }

    // Lower change by number of participants
    if (matchParticipants.length > 2) {
        // Participant decrease is 1-10
        let participantsDecrease;
        if (matchParticipants.length > 11) {
            participantsDecrease = 10;
        } else {
            participantsDecrease = matchParticipants.length - 2;
        }
        change -= participantsDecrease;
    }

    // Increase change for gimmick match
    if (matchGimmick) {
        let matchGimmickFatigueIncrease = getMatchGimmickFatigueIncrease(matchGimmick);
        // Check for traits that affect gimmick match fatigue increase
        for (let trait of superstar.traits) {
            let traitData = traitsData[trait];
            // Get gimmick match expert trait data
            if (trait.includes('Match Expert') && matchGimmick.name === trait.split(' Match Expert')[0]) {
                traitData = traitsData['Match Expert'];
            }
            if (traitData && traitData['gimmick_match_fatigue_multiplier']) {
                matchGimmickFatigueIncrease *= traitData['gimmick_match_fatigue_multiplier'];
            }
        }
        change += matchGimmickFatigueIncrease;
    }

    // Lower change for weekly show
    if (weeklyShow) {
        change *= 0.8;
    }

    // Lower change for tag match
    if (matchType === 'tag') {
        change -= 3;
    }

    // Check for traits that affect fatigue change
    for (let trait of superstar.traits) {
        let traitData = traitsData[trait];
        if (traitData && traitData['weekly_show_match_fatigue_change'] && weeklyShow) {
            change += traitData['weekly_show_match_fatigue_change'];
        }
        if (traitData && traitData['monthly_event_match_fatigue_change'] && !weeklyShow) {
            change += traitData['monthly_event_match_fatigue_change'];
        }
    }

    // Lower change by tournament rounds
    if (tournament) {
        if (tournament.rounds > 9) {
            // Keeps change at same value for 10 or more rounds
            change *= (4.5 / tournament.rounds);
        } else {
            change -= tournament.rounds;
        }
    }

    // Minimum change
    if (change <= 1) {
        change = 1;
    }

    return Math.round(change);
}

function updateSuperstarPopularity(superstar, popularityChange, decrease = false, hotMatch = false, isSegment = false) {  // update_superstar_popularity
    // Popularity change is positive integer for matches, positive or negative for segments
    let newPopularity;

    if (decrease) {
        newPopularity = superstar.popularity - popularityChange;
    } else {
        newPopularity = superstar.popularity + popularityChange;
    }

    // Logarithmic change
    if (newPopularity > 1000 || superstar.faceOfTheCompany) {
        try {
            // New fotc
            if (superstar.popularity < 1000) {
                let over1000Value = newPopularity - 1000;
                if (over1000Value >= 1) {
                    popularityChange = Math.round(Math.log2(over1000Value) * 1.75) + (1000 - superstar.popularity);
                }
            }
            // Existing fotc
            else {
                if (Math.abs(popularityChange) >= 1) {
                    popularityChange = Math.round(Math.log2(Math.abs(popularityChange)) * 1.75);
                }
                if (isSegment && popularityChange < 0) {
                    // Reverse popularity change for segments as value can be negative
                    popularityChange *= -1;
                }
            }
        } catch (error) {
            captureError(error)
        }
        // Increase if hot match
        if (decrease && hotMatch) {
            popularityChange *= -0.5;
        }
    }

    if (decrease) {
        superstar.popularity -= popularityChange;
    } else {
        superstar.popularity += popularityChange;
    }

    return popularityChange;
}

async function getSuperstarMoraleChange({changeType, matchParticipants = null, positive = false,
                                   popularityDifference = null, weeklyShow = false, championship = null,
                                   feudParticipants = null} = {}) {  // get_superstar_morale_change
    let change;
    if (changeType === 'match_result') {
        change = await getSuperstarMoraleChangeForMatch(matchParticipants, popularityDifference, weeklyShow, positive);
    } else if (changeType === 'championship_result') {
        change = getSuperstarMoraleChangeForChampionship(championship, positive);
    } else if (changeType === 'championship_match') {
        change = getSuperstarMoraleChangeForChampionshipMatch(championship);
    } else if (changeType === 'main_event') {
        change = getSuperstarMoraleChangeForMainEvent(weeklyShow);
    } else if (['hot_match', 'hot_feud', 'hot_segment'].includes(changeType)) {
        change = 5;
    } else if (changeType === 'feud_started') {
        change = await getSuperstarMoraleChangeForFeudStarted(feudParticipants, popularityDifference);
    } else if (changeType === 'silly_failure') {
        change = -5;
    } else if (changeType === 'annual_tournament_won') {
        change = 20;
    }
    return Math.round(change);
}

async function getSuperstarMoraleChangeForMatch(participants, popularityDifference, weeklyShow, positive) {  // get_superstar_morale_change_for_match
    let change = 5;

    if (positive) {
        if (popularityDifference >= 0) {
            change -= popularityDifference / 200;
            if (change < 0) {
                change = 0;
            }
        } else {
            change += popularityDifference / -40;
            if (change > 15) {
                change = 15;
            }
        }
    } else {
        if (popularityDifference >= 0) {
            change += popularityDifference / 25;
            if (change > 25) {
                change = 25;
            }
        } else {
            change -= popularityDifference / -200;
            if (change < 0) {
                change = 0;
            }
        }
    }

    // Divide match loss morale change by number of opponents
    if (!positive) {
        const numberOfOpponents = participants.length - 1;
        if (numberOfOpponents > 0) {
            change /= numberOfOpponents;
        }
    }

    if (weeklyShow) {
        change /= 2;
    }

    if (!positive) {
        change *= -1;
    }
    let superstars = (await Promise.all(participants.map(x => getRosterMemberSuperstars(x)))).flat();
    if (superstars.every(s => s.faceOfTheCompany)) {
        change /= 3;
    }

    return change;
}

function getSuperstarMoraleChangeForChampionship(championship, positive) {  // get_superstar_morale_change_for_championship
    const championshipsWins = {'S': 15, 'A': 12, 'B': 10, 'C': 8};
    let change = championshipsWins[championship.prestige];
    if (!positive) {
        change *= -1;
    }
    return change;
}

function getSuperstarMoraleChangeForChampionshipMatch(championship) {  // get_superstar_morale_change_for_championship_match
    const championshipsMatches = {'S': 4, 'A': 3, 'B': 2, 'C': 1};
    return championshipsMatches[championship.prestige];
}

async function getSuperstarMoraleChangeForFeudStarted(participants, popularityDifference) {  // get_superstar_morale_change_for_feud_started
    let change = 0;
    if (Math.abs(popularityDifference) >= 200) {
        if (popularityDifference >= 0) {
            change -= popularityDifference / 30;
            if (change < -20) {
                change = -20;
            }
        } else {
            change += popularityDifference / -40;
            if (change > 15) {
                change = 15;
            }
        }
    }
    let superstars = (await Promise.all(participants.map(x => getRosterMemberSuperstars(x)))).flat();
    if (superstars.every(s => s.faceOfTheCompany)) {
        change /= 3;
    }
    return change;
}

function getSuperstarMoraleChangeForMainEvent(weeklyShow) {  // get_superstar_morale_change_for_main_event
    let change;
    if (weeklyShow) {
        change = 1;
    } else {
        change = 3;
    }
    return change;
}

async function vacateChampionships({superstar, championships, month, year, tagTeam = null, company = null,
                                   checkTalentRequest = false, championshipsToVacate = null}) {  // vacate_championships
    const vacated = [];
    if (!championshipsToVacate) {
        championshipsToVacate = await getSuperstarChampionshipsToVacate(superstar, tagTeam);
    }

    for (let c of championshipsToVacate) {
        if (!c.vacated) {
            const championshipsSet = championships.filter(x => checkAreChampionshipsEqual(x, c) && !x.vacated);
            for (let championship of championshipsSet) {
                championship.vacated = true;
                const champion = await getChampionshipSuperstar(championship);
                champion.popularity -= getChampionshipPopularityDecrease(championship);
                await removeSuperstarChampionships(champion, [championship]);

                // End current reign
                const oldReign = await getChampionshipCurrentReign(championship);
                if (oldReign) {
                    oldReign.endMonth = month;
                    oldReign.endYear = year;
                    oldReign.vacated = true;
                }
            }

            vacated.push(getChampionshipMatchData(c));

            // Check talent request
            if (checkTalentRequest) {
                let requestData = {'championshipId': c.$loki};
                await checkTalentRequestAction({company: company, requestType: 'vacate_championship', talent: superstar,
                    data: requestData});
            }
        }
    }

    return vacated;
}

function getGimmickEffectivenessEffect(effectiveness) {  // get_gimmick_effectiveness_effect
    if (effectiveness === null) {
        return 0
    }
    if (effectiveness >= 80) {
        return 10;
    } else if (effectiveness >= 60) {
        return 5;
    } else if (effectiveness >= 40) {
        return 0;
    } else if (effectiveness >= 20) {
        return -5;
    } else if (effectiveness >= 0) {
        return -10;
    } else {
        return 0;
    }
}

async function retireSuperstar(superstar, roster, championships, month, year, company) {  // retire_superstar
    let data = {};
    let rosterCompany = await getRosterCompany(roster);

    if (!superstar.dead) {
        // Set retired, part timer and appearances
        superstar.retired = true;
        superstar.partTimer = false;
        superstar.appearances = null;

        // Add company alert
        if (rosterCompany && rosterCompany.userControlled) {
            let newCompanyAlert = await createCompanyAlert('superstarRetired', superstar.name);
            await addCompanyCompanyAlerts(rosterCompany, [newCompanyAlert]);
        }

        if (rosterCompany) {
            // Check talent request
            await checkTalentRequestAction({company: rosterCompany, requestType: 'write_off', talent: superstar});

            // Add to log
            const newLog = CompanyLog(month, year);
            CompanyLogs.insert(newLog);
            newLog.text = superstar.name;
            newLog.type = 'retirement';
            await addCompanyCompanyLogs(rosterCompany, [newLog]);
        }
    }

    // Vacate championships
    data['vacated'] = await vacateChampionships({superstar, championships, month, year, company, checkTalentRequest: true});

    // Remove tag teams
    data['tagTeams'] = [];
    for (const tagTeam of (await getSuperstarTagTeams(superstar))) {
        await removeTagTeam(tagTeam);
        if (!tagTeam.temporary) {
            data['tagTeams'].push(tagTeam.name);
        }
    }

    // Get hall of fame ceremony text
    if (superstar.popularity >= 780 && !superstar.hallOfFamer) {
        superstar.hallOfFamer = true;
        data['hallOfFame'] = generateHallOfFameText(superstar, (await getRosterSuperstars(roster)));
    }
    else {
        data['hallOfFame'] = false;
    }

    data['name'] = superstar.name;

    return data;
}

function generateHallOfFameText(superstar, rosterSuperstars) {  // hall_of_fame
    const data = [];
    const speeches = [
        `They say you can be anything you want. They say a lot of stuff, really, and almost all of it is bs. ` +
        `Well, ever since I was a child, I wanted to be a wrestler. And someone told me I could. That's all I ` +
        `needed. Ever since then, every ounce of my soul has gone into it: from watching the superstars on ` +
        `the TV, to attending my local indie wrestling promotion, to ` +
        `training at the dojo, all the way to getting to the big leagues. It's been long and hard, and at times ` +
        `almost impossible to keep hope. Losses, injuries, being fired. It's not an easy life. Divorces. ` +
        `No, it's never been easy. I didn't expect it to be. But I couldn't stop. I had to wrestle. If you want ` +
        `anything as bad, don't stop. Work hard enough and, with some luck, you'll end up somewhere here. ` +
        `You can be anything you want. Thank you.`,

        `You don't know how surreal this is, ha ha. I've seen so many of these speeches ... I couldn't imagine ` +
        `giving one myself. You people have brought me here, thank you so much for that. Thanks to all the ` +
        `wrestlers in the back. ${getRandomChoice(rosterSuperstars).name} for the advice that took me one step further, ` +
        `always. ${getRandomChoice(rosterSuperstars).name}, man, I had so much ` +
        `fun messing around with you. To all the management for believing in me. ` +
        `I just can't believe this. Maybe in a few weeks I'll get used to being a Hall of Famer. ` +
        `It's been a hell of a ride.`,

        `Thank you. You know, they told me at one point that wrestling was not for me. They told me to quit, ` +
        `to go get a real job. They didn't know the passion, the love and the desire to get in that ring that ` +
        `I had. They couldn't ... they couldn't feel it. But every wrestler here knows it. I'm damn sure. ` +
        `Don't you dare believe anyone who tells you to stop doing this, doing what you love. Look around you ` +
        `... do it for these fans. They'll love you for it, more than you can imagine. And I love them back ` +
        `just as much.`
    ];
    const comments = [`${superstar.name} was one of the best in the business.`,
        `It was, indeed, a privilege to work with ${superstar.name}.`,
        `${superstar.name} deserves to go into the hall of fame. A legend, for sure.`,
        `${superstar.name} was and still is one of my idols, someone who I grew up watching. All I can say about the induction is, about damn time, huh?`,
        `The contributions ${superstar.name} made to the wrestling business will never be forgotten.`,
        `${superstar.age} was still too soon for ${superstar.name}'s retirement, but there are times when you have to think about other chapters of your life.`,
        `${superstar.name} was one of the greatest of all time, no doubt about it.`,
        `I remember one day ${superstar.name} stole my towel. I think ${superstar.pronoun} still has it.`,
        `One night, I was teaming up with ${superstar.name} and I was nervous. ${superstar.name} told me to look at the twenty thousand people all around us, told me they all came to see us and that we were gonna send them home happy. We had a classic match that night.`,
        `The fans would be hard pressed to find a better match of mine than the one I had with ${superstar.name}.`,
        `You know those superstars that just have 'it'. I don't know what that is, but I know for sure that ${superstar.name} did have it.`,
        `This is a sad day for our business and for me. But ${superstar.name} has left us inspired to continue to be the best we can.`,
        `Today, it is my honor to induct ${superstar.name} into the Hall of Fame. ${superstar.name} had an illustrious career, one that helped this company in more ways than I can count. But ${superstar.name} also helped all of us, all of the superstars in the back. ${superstar.name} was a joy to be around, an enthusiastic worker, a great friend, and now, deservedly, a legend.`];

    // Randomize choices
    shuffle(comments);
    let superstars = [...rosterSuperstars];
    shuffle(superstars);

    // Add comments by other superstars
    let limit = superstars.length < 3 ? superstars.length : 3;
    for (let x of Array(limit).keys()) {
        let comment = {};
        comment['content'] = comments[x];
        comment['superstar'] = superstars[x].name;
        data.push(comment);
    }

    // Add speech by superstar
    let speech = {};
    speech['content'] = getRandomChoice(speeches);
    speech['superstar'] = superstar.name;
    data.push(speech);

    return data;
}

async function getFutureSuperstarsToAdd(roster, month, year) {  // get_future_superstars_to_add
    // Go through roster's superstars, checking if monthToAppearIn is equal or lesser than months played
    const toAdd = [];
    const months = (year * 12) + month;
    for (const superstar of (await getRosterSuperstars(roster))) {
        if (superstar.monthToAppearIn !== null && superstar.monthToAppearIn <= months) {
            toAdd.push(superstar);
        }
    }
    return toAdd;
}

async function addFutureSuperstar(superstar, roster) {  // add_future_superstar
    await addRosterSuperstars(roster, [superstar]);
    superstar.monthToAppearIn = null;
    return superstar;
}

function processSuperstarTemporaryInjury(superstar, event) {  // process_superstar_temporary_injury
    if (superstar.temporaryInjury) {
        const superstarGraphic = superstar.graphic;
        if (superstarGraphic) {
            if (superstarGraphic['temporaryInjury']) {
                // Remove temporary injury graphic if set (removed after 1 event on which superstar is available)
                if (checkSuperstarBrandAvailability(event, superstar)) {
                    superstar.graphic = removeSuperstarGraphicKey(superstarGraphic, 'temporaryInjury');
                    superstar.temporaryInjury = null;
                }
            } else {
                // Add temporary injury graphic if not set (added after event)
                superstar.graphic = addSuperstarGraphicTemporaryInjury(superstarGraphic, superstar.temporaryInjury);
            }
        } else {
            superstar.temporaryInjury = null;
        }
    }
    return superstar;
}

function processSuperstarTemporaryTrophy(superstar) {  // process_superstar_temporary_trophy
    // Remove trophy graphic if set (removed after 1 month)
    const superstarGraphic = superstar.graphic;
    if (superstarGraphic && typeof superstarGraphic === 'object' && superstarGraphic['temporaryTrophy']) {
        superstar.graphic = removeSuperstarGraphicKey(superstarGraphic, 'temporaryTrophy');
    }
    return superstar;
}

async function processSuperstarLeavingCompany(superstar, company, disbandTagTeams = true, addNews = true, transfer = true) {  // process_superstar_leaving_company
    const game = await getCompanyGame(company);
    const mainCompany = await getGameMainUserCompany(game);
    const indieRoster = await getCompanyRosterByType(mainCompany, 'indie');
    const indieAvailableRoster = await getCompanyRosterByType(mainCompany, 'indieAvailable');
    const month = game.monthCount;
    const year = game.year;

    // Vacate championships
    const vacated = [];
    const vacatedChampionships = await vacateChampionships({superstar: superstar,
        championships: (await getCompanyChampionships(company)), month, year});
    if (vacatedChampionships.length > 0) {
        vacated.push(...vacatedChampionships);
    }

    // Disband tag teams
    let disbanded = [];
    if (disbandTagTeams) {
        disbanded = await removeSuperstarTagTeams(superstar);
    }

    // Remove relationships
    await removeSuperstarFactionRelationships(superstar, month, year);
    await removeSuperstarManagerRelationships(superstar);
    superstar.brandName = null;

    // Remove feuds
    for (const feud of (await getSuperstarFeuds(superstar))) {
        if (!feud.ended) {
            feud.ended = true;
            feud.endMonth = month;
            feud.endYear = year;

            // For ending potential feuds
            if (!feud.started) {
                feud.rating = null;
            } else {
                feud.rating = await getFeudRating(feud);
            }
        }
    }

    // Transfer talent
    if (transfer) {
        if (game.settings['all_indies_available']) {
            await transferTalentToRoster(superstar, indieAvailableRoster, false);
        }
        else {
            await transferTalentToRoster(superstar, indieRoster, false);
        }
    }

    if (company.userControlled) {
        const newCompanyAlert = await createCompanyAlert('leftCompany', superstar.name);
        await addCompanyCompanyAlerts(company, [newCompanyAlert]);
    }

    // Make superstar happy again
    changeSuperstarMoraleToHappy(superstar);

    // Delete all relationships, add former company relationship
    for (const relationship of (await getSuperstarRelationships(superstar))) {
        await Relationships.remove(relationship)
    }
    await addFormerCompanyRelationship(superstar, company);

    // Delete talent requests
    for (const talentRequest of (await getSuperstarTalentRequests(superstar))) {
        await TalentRequests.remove(talentRequest)
    }

    // Add news
    if (addNews) {
        let newsItem = await generateNewsItem({
            company, month: game.newsMonth, year: game.newsYear, superstar, newsType: 'superstar_released_by_company'
        });
        await addCompanyNewsItems(mainCompany, [newsItem]);
    }

    // Add messages
    if (company.userControlled) {
        const newMessage = await createLeftCompanyMessage(superstar, month, year, company, disbanded, vacated);
        await addCompanyMessages(company, [newMessage]);

        if (getRandomInt(0, 100) <= 50) {
            const newMessage = await createLeftCompanySuperstarMessage(superstar, month, year);
            await addCompanyMessages(company, [newMessage]);
        }
    } else {
        const scout = getRandomStaffMemberByRole((await getCompanyStaff(mainCompany)), 'scout');
        const newMessage = await createCompetitorSuperstarLeftMessage(superstar, company, month, year, scout);
        await addCompanyMessages(mainCompany, [newMessage]);
    }

    // Process POW stars leaving
    if (company.storyName === 'passion') {
        await processPowSuperstarLeavesCompany(superstar, company);
    }

    // Remove rejected by company offers so company can no longer block offers
    const negotiations = (await getSuperstarNegotiations(superstar)).filter(x =>
        ['rejected_by_company', 'negotiating'].includes(x.status));
    for (const negotiation of negotiations) {
        await Negotiations.remove(negotiation);
    }

    return true;
}

function recoverSuperstarFatigue(superstar, usedAtEvent, weeklyShow, rosterBrands, game) {  // recover_superstar_fatigue
    const fatigueRecovered = getSuperstarFatigueRecovery(usedAtEvent, weeklyShow, rosterBrands, game);
    updateSuperstarFatigue(superstar, -fatigueRecovered);
    return true;
}

function getSuperstarFatigueRecovery(usedAtEvent, weeklyShow, rosterBrands, game) {  // get_superstar_fatigue_recovery
    let recovery;

    if (game.numberOfWeeklyShows) {
        // Recovery if weekly shows on
        recovery = 10;
        // For weekly show, divide recovery by number of brands
        if (weeklyShow && rosterBrands.length) {
            recovery /= rosterBrands.length;
            if (rosterBrands.length > 1) {
                recovery -= 1;
            }
        }
    } else {
        // Recovery if no weeklies
        recovery = 15;
    }

    // Increase recovery if not used at event
    if (!usedAtEvent) {
        recovery += 2;
    }

    return Math.floor(recovery);
}

async function processSuperstarMorale(superstar, company, game) {  // process_superstar_morale
    await processSuperstarLeaving(superstar, company, game);

    if (superstar.morale < 20 && !superstar.unhappy && !game.settings['no_unhappiness']) {
        await setSuperstarUnhappy(superstar, company);
    }
    if ((superstar.morale >= 20 || game.settings['no_unhappiness']) && superstar.unhappy) {
        await setSuperstarNotUnhappy(superstar, company);
    }

    // Reset low morale if 'no_unhappiness' option selected
    if (game.settings['no_unhappiness'] && superstar.morale < 20) {
        superstar.morale = 20;
    }

    return superstar;
}

async function processSuperstarLeaving(superstar, company, game) {  // process_superstar_leaving
    if (superstar.unhappy && superstar.morale < 20 && superstar.contractMonthsRemaining === null && !game.settings['no_unhappiness']) {
        await setSuperstarLeaving(superstar, company);
    }
    if (superstar.contractMonthsRemaining !== null && (superstar.morale >= 60 || game.settings['no_unhappiness'])) {
        await setSuperstarNotLeaving(superstar, company);
    }
    return superstar;
}

async function setSuperstarUnhappy(superstar, company) {  // set_superstar_unhappy
    const game = await getCompanyGame(company);
    const talentManager = getRandomStaffMemberByRole((await getCompanyStaff(company)), 'talent_manager');

    superstar.unhappy = true;

    // Add company alert
    if (company.userControlled) {
        const newCompanyAlert = await createCompanyAlert('unhappy', superstar.name);
        await addCompanyCompanyAlerts(company, [newCompanyAlert]);

        // Add unhappy message
        const newMessage = await createUnhappyMessage(superstar, game.monthCount, game.year, talentManager);
        await addCompanyMessages(company, [newMessage]);
    }

    return superstar;
}

async function setSuperstarNotUnhappy(superstar, company) {  // set_superstar_not_unhappy
    const game = await getCompanyGame(company);
    const talentManager = getRandomStaffMemberByRole((await getCompanyStaff(company)), 'talent_manager');

    superstar.unhappy = false;

    if (superstar.contractMonthsRemaining === null) {
        let xpGained = null;
        if (talentManager) {
            xpGained = 15;
            const ageMultiplier = getStaffAgeMultiplier(talentManager);
            xpGained = Math.round(xpGained * ageMultiplier);
            await updateStaffMemberXp(talentManager, xpGained, company, game);
        }

        if (company.userControlled) {
            const newCompanyAlert = await createCompanyAlert('notUnhappy', superstar.name);
            await addCompanyCompanyAlerts(company, [newCompanyAlert]);

            const newMessage = await createNoLongerUnhappyMessage(superstar, game.monthCount, game.year, talentManager, xpGained);
            await addCompanyMessages(company, [newMessage]);
        }
    }

    return superstar;
}

async function setSuperstarLeaving(superstar, company) {  // set_superstar_leaving
    const game = await getCompanyGame(company);
    const mainCompany = await getGameMainUserCompany(game);
    const talentManager = getHighestLevelStaffMemberByRole((await getCompanyStaff(company)), 'talent_manager');

    // Get chance to leave
    const talentManagerLevel = talentManager ? talentManager.level : 1;
    const leavingChances = {1: 75, 2: 60, 3: 45};
    let leavingChance = leavingChances[talentManagerLevel] || 45;

    // Check for affect leaving chance trait
    for (const trait of superstar.traits) {
        const traitData = traitsData[trait];
        if (traitData && traitData['leaving_chance_multiplier']) {
            leavingChance *= traitData['leaving_chance_multiplier'];
        }
    }

    if (getRandomInt(0, 100) <= leavingChance) {
        superstar.contractMonthsRemaining = getRandomInt(3, 8);

        if (company.userControlled) {
            const newCompanyAlert = await createCompanyAlert('leavingCompany', superstar.name);
            await addCompanyCompanyAlerts(company, [newCompanyAlert]);

            // Add leaving message from talent manager
            const newMessage = await createLeavingMessage(superstar, game.monthCount, game.year, talentManager);
            await addCompanyMessages(company, [newMessage]);
        }
        // If competitor superstar, add message from scout
        else {
            const scout = getRandomStaffMemberByRole((await getCompanyStaff(mainCompany)), 'scout');
            const newMessage = await createCompetitorSuperstarLeavingMessage(superstar, company, game.monthCount, game.year, scout);
            await addCompanyMessages(mainCompany, [newMessage]);
        }

        let newsItem = await generateNewsItem({
            company, month: game.newsMonth, year: game.newsYear, superstar, newsType: 'superstar_leaving'
        });
        await addCompanyNewsItems(mainCompany, [newsItem]);
    }

    return superstar;
}

async function setSuperstarNotLeaving(superstar, company) {  // set_superstar_not_leaving
    const game = await getCompanyGame(company);
    const mainCompany = await getGameMainUserCompany(game);
    const talentManager = getRandomStaffMemberByRole((await getCompanyStaff(company)), 'talent_manager');

    superstar.contractMonthsRemaining = null;

    if (company.userControlled) {
        const newCompanyAlert = await createCompanyAlert('notLeavingCompany', superstar.name);
        await addCompanyCompanyAlerts(company, [newCompanyAlert]);

        const newMessage = await createNotLeavingMessage(superstar, game.monthCount, game.year, talentManager);
        await addCompanyMessages(company, [newMessage]);
    }

    let newsItem = await generateNewsItem({
        company, month: game.newsMonth, year: game.newsYear, superstar, newsType: 'superstar_staying'
    });
    await addCompanyNewsItems(mainCompany, [newsItem]);

    return superstar;
}

function addSuperstarGraphicTemporaryInjury(graphic, injuryType) {  // add_superstar_graphic_temporary_injury
    let objectsDict = {
        'left_eye': 0, 'right_eye': 1, 'left_arm': 2, 'right_arm': 3, 'forehead': getRandomChoice([4, 5]),
        'forehead_left': 4, 'forehead_right': 5, 'forehead_full': 6
    };

    // Get object number
    let objectNumber = objectsDict[injuryType] || 5;

    // Add temporary injury
    graphic = JSON.parse(JSON.stringify(graphic));
    graphic['temporaryInjury'] = {'object': objectNumber, 'colors': ['0xFFFFFF']};

    // Add to alternate attires
    let alternateAttires = graphic['alternate_attires'];
    if (alternateAttires) {
        let newAlternateAttires = [];
        for (let alt of alternateAttires) {
            let altGraphic = JSON.parse(JSON.stringify(alt));
            altGraphic['temporaryInjury'] = {'object': objectNumber, 'colors': ['0xFFFFFF']};
            newAlternateAttires.push(altGraphic);
        }
        graphic['alternate_attires'] = newAlternateAttires;
    }

    return graphic;
}

function addSuperstarGraphicTemporaryTrophy(graphic) {  // add_superstar_graphic_temporary_trophy
    // Add trophy
    graphic = JSON.parse(JSON.stringify(graphic));
    graphic['temporaryTrophy'] = {'object': 0, 'colors': ['0xFFFFFF']};

    // Add to alternate attires
    let alternateAttires = graphic['alternate_attires'];
    if (alternateAttires) {
        let newAlternateAttires = [];
        for (let alt of alternateAttires) {
            let altGraphic = JSON.parse(JSON.stringify(alt));
            altGraphic['temporaryTrophy'] = {'object': 0, 'colors': ['0xFFFFFF']};
            newAlternateAttires.push(altGraphic);
        }
        graphic['alternate_attires'] = newAlternateAttires;
    }

    return graphic;
}

function removeSuperstarGraphicKey(graphic, key) {  // remove_superstar_graphic_key
    graphic = JSON.parse(JSON.stringify(graphic));

    // Remove key
    delete graphic[key];

    // Remove from alternate attires
    let alternateAttires = graphic['alternate_attires'];
    if (alternateAttires) {
        let newAlternateAttires = [];
        for (let alt of alternateAttires) {
            let altGraphic = JSON.parse(JSON.stringify(alt));
            delete altGraphic[key];
            newAlternateAttires.push(altGraphic);
        }
        graphic['alternate_attires'] = newAlternateAttires;
    }

    return graphic;
}

function removeTraitFromSuperstar(superstar, trait) {  // remove_trait_from_superstar
    const index = superstar.traits.indexOf(trait);
    if (index > -1) {
        superstar.traits.splice(index, 1);
    }
    return superstar.traits;
}

async function addInterestedRelationship(superstar, company) {  // add_interested_relationship
    let relationship = Relationship();
    await Relationships.insert(relationship);
    relationship.interested = true;
    await addSuperstarRelationships(superstar, [relationship]);
    await addCompanyRelationships(company, [relationship]);
    return relationship;
}

async function processSuperstarContract(superstar, company, game) {  // process_superstar_contract
    if (superstar.contractMonthsRemaining !== null && !game.settings['no_unhappiness']) {
        superstar.contractMonthsRemaining -= 1;
        if (superstar.contractMonthsRemaining <= 0) {
            await processSuperstarLeavingCompany(superstar, company);
            return true;
        }
    }
    return false;
}

async function vacateSuperstarChampionships({superstarUid} = {}) {
    let data = {};
    const currentGame = await getCurrentGame();
    const superstar = await Superstars.get(superstarUid);
    const company = await getTalentCompany(superstar);
    data['vacatedChampionships'] = await vacateChampionships({
        superstar, championships: await getCompanyChampionships(company),
        month: currentGame.monthCount, year: currentGame.year, company, checkTalentRequest: true
    });
    db.saveDatabase();
    return data;
}

export { getRankFromPopularity, getInjuryReturnTime, checkAvailability, getSuperstarChampionshipsAll,
    getSuperstarMatchOrSegmentData, getSuperstarDisplayData, getRosterMemberSuperstars,
    getGraphicForSuperstar, checkSuperstarBrandAvailability, getEmptySuperstarGraphic, getSuperstarGenderFromPronoun,
    checkSuperstarGraphicMask, getSuperstarChampionshipsFromCompanyChampionships,
    changeSuperstarMoraleToHappy, changeSuperstarMoraleToUnhappy, removeSuperstarManagerRelationships,
    removeSuperstarFactionRelationships, removeSuperstarsFromManager, addSuperstarsToManager, getSuperstarActiveFactions,
    getSuperstarFreebirdTagChampionships, removeSuperstarTagTeams, getGimmickCombinationResult, getGimmickData,
    endSuperstarInjury, updateSuperstarMorale, getSuperstarManagerUsedForMatchOrSegment,
    checkObjectBrandAvailability, checkSuperstarSegmentAvailability, getSuperstarChampionshipsToVacate,
    getSuperstarLastName, changeSuperstarAttire, getSuperstarCharisma, getSuperstarWorkrate, getSuperstarManagerGraphic,
    getTraitWeightsForSuperstars, getKayfabePointsChange, updateSuperstarKayfabePoints, checkAcquireTrait,
    debutGimmick, evaluateInjury, checkForSuperstarInjury, addInjuryToSuperstar,
    checkSuperstarWorkThroughInjury, addKayfabeInjuryToSuperstar, addNextGimmickBoost, removeSuperstarGraphicHair,
    removeSuperstarGraphicMask, updateSuperstarFatigue, getSuperstarFatigueChangeForMatch, updateSuperstarPopularity,
    addSuperstarGraphicHair, getSuperstarMoraleChange, checkIfCanUnlearnTrait, vacateChampionships,
    getGimmickEffectivenessEffect, retireSuperstar, processSuperstarLeaving, processSuperstarTemporaryTrophy,
    processSuperstarTemporaryInjury, processSuperstarLeavingCompany, processSuperstarContract, addInterestedRelationship,
    removeTraitFromSuperstar, getFutureSuperstarsToAdd, addFutureSuperstar, processSuperstarMorale, recoverSuperstarFatigue,
    getNextRank, addSuperstarGraphicTemporaryTrophy, formatSuperstarTrait, vacateSuperstarChampionships}